module.exports = __webpack_public_path__ + "static/img/iphoneEA.3b2c524.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphoneEA.png
// module id = NL1q
// module chunks = 0